import * as THREE from "three";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import {deviceCheck, SELFIE_CAM_WIDTH, SELFIE_CAM_HEIGHT} from "utils";

class SelfieControls {
  constructor(graphics, camera) {
    this.graphics = graphics;
    this.camera = camera || graphics.playCamera;
    this.domElement = graphics.labelRenderer.domElement;

    if (this.camera !== undefined) this.playCam = this.camera.postion;
    if (graphics.avatar.model !== undefined) this.target = this.graphics.avatar.model.position;

    this.isPointerDown = false;

    this.orbit = new OrbitControls(this.camera, this.graphics.canvas);
    this.orbit.enablePan = false;
    this.orbit.maxPolarAngle = Math.PI / 1.5;
    this.orbit.maxDistance = 7;
    this.orbit.minDistance = 3;

    this.currentDevice = deviceCheck();
    this.cameraWidth = SELFIE_CAM_WIDTH[this.currentDevice];
    this.cameraHeight = SELFIE_CAM_HEIGHT[this.currentDevice];

    const camPosition = new THREE.Vector3();
    this.graphics.avatar.model.getWorldDirection(camPosition);
    // set default angle for right hand selfie
    camPosition.applyAxisAngle(new THREE.Vector3(0, 1, 0), (-35 * Math.PI) / 180);
    camPosition.multiplyScalar(5);

    this.camera.position.set(this.target.x + camPosition.x, this.target.y + camPosition.y, this.target.z + camPosition.z);

    this.orbit.target = new THREE.Vector3(this.target.x, this.target.y + 3, this.target.z);
    this.orbit.update();

    graphics.canvas.addEventListener("wheel", this.setIsPointerDown, {
      capture: true,
    });
    graphics.canvas.addEventListener("pointerdown", this.setIsPointerDown, {
      capture: true,
    });

    this.orbit.addEventListener("change", this.orbitChangeHandler);

    this.graphics.selfieControls = this.orbit;

    this.camera.setViewOffset(
      this.graphics.canvas.clientWidth,
      this.graphics.canvas.clientHeight,
      this.cameraWidth,
      this.cameraHeight,
      this.graphics.canvas.clientWidth,
      this.graphics.canvas.clientHeight,
    );

    if (this.graphics.isTouchDevice && this.graphics.joystick.isDynamic) this.addStaticJoystick();
  }

  setIsPointerDown = event => {
    switch (event.type) {
      case "pointerdown":
        this.isPointerDown = true;
        break;
      case "wheel":
        this.isPointerDown = false;
        break;
      default:
        break;
    }
  };

  orbitChangeHandler = () => {
    if (this.isPointerDown === true) {
      this.graphics.avatar.model.lookAt(this.camera.position.x, this.graphics.avatar.model.position.y, this.camera.position.z);
      let rotationVector = this.graphics.avatar.model.rotation.clone();
      this.graphics.avatar.model.body.transform();
      this.graphics.avatar.model.body.setRotation(rotationVector.x, rotationVector.y, rotationVector.z);
      this.graphics.avatar.model.body.refresh();
    }
  };

  dispose = () => {
    // roll back a view offset for camera's default shooting mode
    this.camera.setViewOffset(
      this.graphics.canvas.clientWidth,
      this.graphics.canvas.clientHeight,
      0,
      0,
      this.graphics.canvas.clientWidth,
      this.graphics.canvas.clientHeight,
    );
    // TODO: Lerping
    this.camera.position.addVectors(this.graphics.avatar.model.position, this.graphics.previousCameraOffset);
    this.camera.lookAt(
      this.graphics.avatar.model.position.x,
      this.graphics.avatar.model.position.y + 5,
      this.graphics.avatar.model.position.z,
    );
    this.graphics.onSwitchSelfieMode(false);
    // orbitControl's dispose method
    this.graphics.selfieControls.dispose();
    this.graphics.canvas.removeEventListener("pointerdown", this.setIsPointerDown);
    this.graphics.canvas.removeEventListener("wheel", this.setIsPointerDown);
    // enable all layers to show all players & objects
    this.camera.layers.enableAll();
    delete this.graphics.playControls;
    delete this.graphics.selfieControl;

    if (this.graphics.isTouchDevice && this.graphics.joystick.isDynamic) this.removeStaticJoystick();
  };

  addStaticJoystick() {
    this.graphics.joystick.removeJoystickGuide();

    this.graphics.joystickAxis = this.graphics.joystick.add.axis({
      styles: {
        left: window.innerWidth < 768 ? 40 : 35,
        bottom: window.innerWidth < 768 ? 15 : 35,
        size: window.innerWidth < 768 ? 75 : 100,
      },
    });

    const circle = document.getElementById("joystick");
    circle.style.display = "";
    circle.style.cssText =
      "background: rgba(255, 255, 255, 0.3);position: fixed;width: 96px;height: 96px;cursor: pointer;bottom: 48px;left: 72px;border-radius: 100%;";

    this.graphics.joystickAxis.onMove(event => {
      if (!this.graphics.joystickEnabled) {
        this.graphics.joystickPosition = {top: 0, right: 0};
        this.graphics.joystickRadian = 0;
        return;
      }
      this.graphics.joystickPosition = event;
      this.graphics.joystickRadian = -Math.atan2(event.right, event.top);
    });
  }

  removeStaticJoystick() {
    this.graphics.joystick.removeAxis();
  }
}
export {SelfieControls};
